import { UserGenderTypes, UserGender } from '@booking/entities/user-gender';

export function getPaxGender(gender: string): UserGender {
  return gender === UserGenderTypes.M ?
    UserGender.Male : gender === UserGenderTypes.F ? UserGender.Female :
      Object.values(UserGender)?.includes(gender as UserGender) ? gender as UserGender : null;
}
